import { useForm } from '@mantine/form';
import Form from './form';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from "react-redux";
import toast from "toastr";

const VerifyUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useForm({
    initialValues: {
      Code: ''
    },
    validate: {
      Code: (val: any) => {
        if (!val) return "Verification code is required";
        if (val.length !== 6) return "Code must be 6 digit";
        return null;
      },
    },
  });
  const storedOtpCode = localStorage.getItem("otp");

  const Verify2Fa = (e: any) => {
    e.preventDefault();
    debugger
    form.validate();
    if (form.isValid()) {
      if (form.values.Code === storedOtpCode) {
        const userRoleId = JSON.parse(localStorage.getItem("authUser") || '{}').userRoleId;      
        if (userRoleId === 1) {
          navigate("/manageuser");
        } else if (userRoleId === 2) {
          navigate("/client");
        }
      } else {
        toast.error("Invalid verification code");
      }

    }
  }
  return (
    <Form formData={form} Verify2Fa={Verify2Fa} />
  );
};

export default VerifyUser;




